import DEV from "./DEV";
export { DEV };
import { removeTemporaryGlobals } from "./graphql";
export { removeTemporaryGlobals };
removeTemporaryGlobals();
//# sourceMappingURL=index.js.map